export enum DashboardColor {
  Neutral = 'neutral',
  BrightNeutral = 'bright neutral',
  Yellow = 'yellow',
  Green = 'green',
  Blue = 'blue',
  Purple = 'purple',
}
